import * as angular from "angular";
import {ITemplateCacheService} from "angular";
import {AssessmentComponent} from "./assessment.component";
import {StudyUnitModule} from "../study-unit/study-unit.module";
import {ApplicationModule} from "../application/application.module";
import {AssessmentsComponent} from "./assessments/assessments.component";
import {AssessmentRowComponent} from "./row/assessment-row.component";
import {LoadingModule} from "../loading/loading.module";
import {DisciplineSelectorComponent} from "./discipline-selector/discipline-selector.component";
import {DisciplineService} from "./discipline-selector/discipline.service";
import {AssessmentsButtonComponent} from "./button/assessments-button.component";
import {SearchPrecedentModalComponent} from "./search-precedent/search-precedent-modal.component";
import {AssessmentSharingModalComponent} from "./sharing-modal/assessment-sharing-modal.component";
import {CreatePrecedentModalComponent} from "./create-precedent-modal/create-precedent-modal.component";
import {CourseCodesFilter} from "./assessment.course-code.filter";
import {CreditComponent} from "./credit.component";
import {ExternalUnitComponent} from "./create-precedent-modal/externalUnit.component";

export const AssessmentModule = angular
    .module("app.shared.assessment", [ApplicationModule, LoadingModule, StudyUnitModule])
    .service("disciplineService", DisciplineService)
    .filter("assessmentCourseCodes", CourseCodesFilter)
    .component("assessment", AssessmentComponent)
    .component("assessments", AssessmentsComponent)
    .component("assessmentRow", AssessmentRowComponent)
    .component("assessmentsButton", AssessmentsButtonComponent)
    .component("disciplineSelector", DisciplineSelectorComponent)
    .component("searchPrecedentModal", SearchPrecedentModalComponent)
    .component("assessmentSharingModal", AssessmentSharingModalComponent)
    .component("createPrecedentModal", CreatePrecedentModalComponent)
    .component("credit", CreditComponent)
     .component("externalUnit", ExternalUnitComponent)

    .run(($templateCache: ITemplateCacheService) => {
        $templateCache.put("discipline-selector-item.html", require("./discipline-selector/discipline-selector-item.html"));
        $templateCache.put("external-unit-drop-down.html", require("./create-precedent-modal/external-unit-drop-down.html"));
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/assessment.module.ts